import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=20af57ea&scoped=true&"
import script from "./Panel.vue?vue&type=script&lang=ts&"
export * from "./Panel.vue?vue&type=script&lang=ts&"
import style0 from "./Panel.vue?vue&type=style&index=0&id=20af57ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af57ea",
  null
  
)

export default component.exports